// src/utils/PdfUtils.js
import pdfMake from 'pdfmake/build/pdfmake';
import { vfs } from 'pdfmake/build/vfs_fonts';
import BottomLogo from './../Assets/logo.png'
import TopLogo from './../Assets/TRNS_BLACK.png'

pdfMake.vfs = vfs;

export class PdfUtils {
  static getImageBase64 = async (imagePath) => {
    const response = await fetch(imagePath);
    const blob = await response.blob();
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  static async generatePDF(selectedPerson, t) {
    if (!selectedPerson) return;

    const content = [];
    const topLogoBase64 = await this.getImageBase64(TopLogo);
    const bottomLogoBase64 = await this.getImageBase64(BottomLogo);

    // Add top logo
    content.push({
      image: topLogoBase64,
      width: 100,
      alignment: 'center',
      margin: [0, 0, 0, 20]
    });

    content.push({
      text: t("Informācija no Latvijas Kara muzeja datu bāzes"),
      style: 'title',
      alignment: 'center',
      margin: [0, 20, 0, 20]
    });

    Object.entries(selectedPerson).forEach(([key, value]) => {
      const isTable = key === "table";
      const label = isTable ? t("Datubāze") : t(key);
      const translatedValue = isTable
        ? {
            1: t("Latviešu strēlnieku 2. brigādes apbalvoto karavīru saraksts"),
            2: t("Latviešu SS leģionā mobilizēto saraksts"),
            3: t("Kritušo, bez vēsts pazudušo, ievainoto un gūstā nonākušo latviešu strēlnieku saraksts"),
            4: t("Zedelgemas (Beļģija) karagūstekņu nometnē ieslodzīto latviešu karavīru saraksts"),
            5: t("Latviešu strēlnieku bataljonos (pulkos) dienējušo saraksts"),
            6: t("Kritušo un bez vēsts pazudušo Latviešu SS leģiona karavīru saraksts")
          }[value] || t("Nav minēts")
        : value || t("Nav minēts");

      content.push({
        text: [{ text: `${label}: `, bold: true }, translatedValue],
        margin: [0, 4],
      });
    });

    const docDefinition = {
      content,
      styles: {
        title: {
          fontSize: 16,
          bold: true
        }
      },
      defaultStyle: {
        font: 'Roboto',
        fontSize: 11,
      },
      fonts: {
        Roboto: {
          normal: 'Roboto-Regular.ttf',
          bold: 'Roboto-Medium.ttf',
          italics: 'Roboto-Italic.ttf',
          bolditalics: 'Roboto-MediumItalic.ttf',
        },
      },
      pageMargins: [40, 60, 40, 80],
      footer: function (currentPage, pageCount) {
        return {
          stack: [
            {
              image: bottomLogoBase64,
              width: 25,
              alignment: 'center',
              margin: [0, 10, 0, 5]
            },
            {
              text: t('Avots: Latvijas Kara muzejs'),
              alignment: 'center',
              fontSize: 9,
              margin: [0, 0, 0, 10]
            }
          ]
        };
      },
    };

    let filename = 'person_info.pdf';
    if (selectedPerson.name && selectedPerson.surname) {
      filename = `${selectedPerson.name}_${selectedPerson.surname}.pdf`;
    }

    pdfMake.createPdf(docDefinition).download(filename);
  }
}